module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"jQuery","amd":"jquery","commonjs":"jquery","commonjs2":"jquery"}
 ** module id = 1
 ** module chunks = 0
 **/